import apiClient from './apiClient';

const attendanceService = {
  /**
   * Mark attendance (check-in/check-out)
   */
  mark: async (latitude, longitude, attendanceType = 'check-in') => {
    const response = await apiClient.post('/attendance/mark', {
      latitude,
      longitude,
      attendanceType
    });
    return response.data;
  },

  /**
   * Get all attendance records
   */
  getAll: async (page = 1, limit = 10, filters = {}) => {
    const params = new URLSearchParams({
      page,
      limit,
      ...filters
    });
    const response = await apiClient.get(`/attendance?${params}`);
    return response.data;
  },

  /**
   * Get employee attendance
   */
  getEmployeeAttendance: async (employeeId, month = null) => {
    let url = `/attendance/employee/${employeeId}`;
    if (month) {
      url += `?month=${month}`;
    }
    const response = await apiClient.get(url);
    return response.data;
  },

  /**
   * Verify attendance
   */
  verify: async (id, isVerified, verificationNotes = '') => {
    const response = await apiClient.put(`/attendance/${id}/verify`, {
      isVerified,
      verificationNotes
    });
    return response.data;
  },

  /**
   * Get user's current location
   */
  getCurrentLocation: () => {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject(new Error('Geolocation is not supported'));
      }
      navigator.geolocation.getCurrentPosition(
        (position) => {
          resolve({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude
          });
        },
        (error) => {
          reject(error);
        }
      );
    });
  }
};

export default attendanceService;
